import React from 'react'
import { darken, lighten, makeStyles} from '@material-ui/core';
import { Bar, defaults } from 'react-chartjs-2';
import PropTypes from 'prop-types';

import { COLORS_PROJECT } from '../../constants';

const {color_nav_letter,color_nav,color_back,color_alarm_red,color_alarm_orange,color_alarm_yellow}= COLORS_PROJECT;

defaults.global.defaultFontColor  = darken(color_back,1);



const options = {
    maintainAspectRatio: false,
    responsive: true,
    title:{
        display:true,
        text:'Número de Alertas',
        fontSize:20,
        fontColor: darken(color_nav,0.45),
    },
    legend:{
        display: false,
        position:'top',
        labels:{
            fontColor: darken(color_nav_letter,1),
        },
    },
    scales:{
        xAxes: [{
            gridLines:{
                color: color_back,
            }
        }],
        yAxes: [{
            gridLines:{
                color: color_back,
            },
            ticks: {
                beginAtZero: true,
                callback: function(value) {if (value % 1 === 0) {return value;}}
            }
        }],
    },
}

const useStyles = makeStyles((theme) => ({
    sizeChart: {
        width: '100%',
        height: '350px',
        backgroundColor: lighten(color_back, 0.8),//lighten(theme.palette.primary.main,0.5),
    },
}));
//let red_distance,orange_distance,yellow_distance;

//if(color_alarm_yellow===undefined){
   // color_alarm_yellow= 0 ;
   // orange_distance= 0;
  //  yellow_distance= 0 ;
//}
/*else{
    red_distance= redLightning.rayos_detectados_aoc[0].aoc ;
    orange_distance= orangeLightning.rayos_detectados_ma[0].ma ;
    yellow_distance= yellowLightning.rayos_detectados_ca[0].ca ;
} */
const red = color_alarm_red
const orange= color_alarm_orange
const yellow= color_alarm_yellow

export const BarChart = ({
    dataChart = [50,37,41],
    size = 350,
    color_alarm_yellow=yellow,
    color_alarm_orange=orange,
    color_alarm_red=red,
    nameColor1='Amarilla',
    nameColor2='Naranja',
    nameColor3='Roja',
}) => {
    
    const classes= useStyles();


    const data = {
        labels: [nameColor1,nameColor2,nameColor3],
        datasets:[{
            label: 'Alertas',
            backgroundColor: [color_alarm_yellow,color_alarm_orange,color_alarm_red],
            borderColor: [darken(color_alarm_yellow,0.4),darken(color_alarm_orange,0.4),darken(color_alarm_red,0.4)],
            borderWidth: 1,
            hoverBackgroundColor: [lighten(color_alarm_yellow,0.1),lighten(color_alarm_orange,0.1),lighten(color_alarm_red,0.1)],
            hoverBorderColor: [lighten(color_alarm_yellow,0.4),lighten(color_alarm_orange,0.4),lighten(color_alarm_red,0.4)],
            
            data: dataChart,
        }]
    }
    return (
        <>
            <div className={classes.sizeChart} style={{ height: size }}>
                <Bar data={data} options={options} />
            </div>
        </>
    )
}


BarChart.propTypes = {
   dataChart: PropTypes.array.isRequired,
   size: PropTypes.number,
};